import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import messages from '../../../services/messages'
import { useTheme } from '@material-ui/core/styles'

import {
  findIdleMsg,
  getTriggers,
  sortConversation,
} from '../../../utils/messages'

import { setConversations } from '../../../redux/conversations/actions'

import { Divider, Tab, Tabs, CircularProgress } from '@material-ui/core'
import { AccessTimeRounded as TimeIcon } from '@material-ui/icons'
import {
  CheckCircleRounded as CheckIcon,
  NotificationImportantRounded as NotificationIcon,
  Brightness2Rounded as MoonIcon,
  CancelPresentationRounded as CancelIcon,
  AddComment as AddIcon,
} from '@material-ui/icons'

import { setActiveConversation } from '../../../redux/activeConversation/actions'

import Icon from '../../atoms/display/icon'
import ChatItem from '../../molecules/chat/item'
import QueueIndicator from '../../molecules/queue/queueIndicator'
import Typography from '../../atoms/display/typography'
import CreateAttendance from '../dialogs/createAttendance'

import useStyles from './messagesListStyle'

const MessageList = (props) => {
  const size = useSelector((state) => state.preferences)
  const activeResizeButton = ['telefone']

  const features = useSelector((state) => state.features)
  const objFeatureTab = useMemo(() => {
    return features?.find((e) => e.name === 'Tab')
  }, [features])

  const theme = useTheme()
  const { t } = useTranslation()

  let useStylesParams = {
    size: size,
  }
  const classes = useStyles(useStylesParams)

  const dispatch = useDispatch()

  const conversations = useSelector(
    (state) => state.conversations.conversations
  )
  const activeConversation = useSelector((state) => state.activeConversation)
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )
  const permissions_extra =
    useSelector((state) => state?.permissions_extra) || {}

  const [dialogsOpen, setDialogsOpen] = useState({})
  const [chats, setChats] = useState([])
  const [loading, setLoading] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [filterValues, setFilterValues] = useState({
    active: { enable: true, count: 0 },
    inactive: { enable: false, count: 0 },
    closed: { enable: false, count: 0 },
    'pos-chat': { enable: false, count: 0 },
  })

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleDialogs = (dialog, e = true) => {
    setDialogsOpen((openDialogs) => ({
      ...openDialogs,
      [dialog]: e,
    }))
  }

  const updateFilterValues = useCallback(
    (chats) => {
      setFilterValues((prev) => {
        let temp = {
          active: { enable: prev.active.enable, count: 0 },
          inactive: { enable: prev.inactive.enable, count: 0 },
          closed: { enable: prev.closed.enable, count: 0 },
          'pos-chat': { enable: prev.closed.enable, count: 0 },
        }

        chats?.forEach(
          (el) => temp?.[el.status]?.count >= 0 && temp[el.status].count++
        )

        return temp
      })
    },
    [setFilterValues]
  )

  const updateActiveFilter = (status) => {
    if (
      filterValues?.[status]?.enable &&
      (conversation?.status === status ||
        (status === 'closed' && conversation?.status === 'pos-chat'))
    ) {
      dispatch(setActiveConversation(null))
    }

    if (status === 'closed') {
      setFilterValues((prev) => ({
        ...prev,
        ['closed']: { ...prev['closed'], enable: !prev['closed']?.enable },
        ['pos-chat']: {
          ...prev['pos-chat'],
          enable: !prev['pos-chat']?.enable,
        },
      }))
    } else {
      setFilterValues((prev) => ({
        ...prev,
        [status]: { ...prev[status], enable: !prev[status]?.enable },
      }))
    }
  }

  const isVisibleChat = (chat) => {
    if (chat) return filterValues[chat.status]?.enable
    return false
  }

  const sortQueue = useCallback(
    (list) => {
      let temp = list?.sort((a, b) => sortConversation(a, b, tabValue))

      const chatsTelefone = temp?.filter((el) => el.status === 'telefone')

      temp = temp?.filter((el) => el.status !== 'telefone')

      return [...chatsTelefone, ...temp]
    },
    [sortConversation, tabValue]
  )

  const renderTabs = () => {
    if (size === 'small') {
      return <></>
    } else {
      return (
        <>
          <div style={{ height: 20 }} />
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            variant="fullWidth"
            textColor="primary"
            style={{ marginLeft: 15, marginRight: 15 }}
          >
            <Tab label={t('commons.inbox')} />
            <Tab label={t('commons.reply')} />
          </Tabs>
        </>
      )
    }
  }

  const renderFilter = () => {
    return (
      <div className={classes.filters}>
        <div
          className={
            filterValues.active.enable
              ? classes.filterButtonActive
              : classes.filterButton
          }
          onClick={() => updateActiveFilter('active')}
        >
          <div className={classes.filterContent}>
            <Typography>{filterValues.active.count}</Typography>
            <div className={classes.filterIcons}>
              <CheckIcon className={classes.filterButtonIcon} />
            </div>
          </div>
          <div
            style={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" className="description">
              {t('buttons.attending')}
            </Typography>
          </div>
        </div>
        <div
          className={
            filterValues.inactive.enable
              ? classes.filterButtonActive
              : classes.filterButton
          }
          onClick={() => {
            updateActiveFilter('inactive')
          }}
        >
          <div className={classes.filterContent}>
            <Typography>{filterValues.inactive.count}</Typography>
            <div className={classes.filterIcons}>
              <MoonIcon className={classes.filterButtonIcon} />
            </div>
          </div>
          <div
            style={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" className="description">
              {t('buttons.idle')}
            </Typography>
          </div>
        </div>
        <div
          className={
            filterValues.closed.enable
              ? classes.filterButtonActive
              : classes.filterButton
          }
          onClick={() => updateActiveFilter('closed')}
        >
          <div className={classes.filterContent}>
            <Typography>
              {filterValues.closed.count + filterValues['pos-chat'].count}
            </Typography>
            <div className={classes.filterIcons}>
              <CancelIcon className={classes.filterButtonIcon} />
            </div>
          </div>
          <div
            style={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant="body2" className="description">
              {t('buttons.closed')}
            </Typography>
          </div>
        </div>
      </div>
    )
  }

  const renderList = () => {
    return (
      <div className={classes.content}>
        {chats?.filter(isVisibleChat).map((el, key) => {
          return (
            <ChatItem
              key={key}
              userStatus={3}
              splash={0}
              lastMessage={t('commons.lastMessage')}
              data={el}
              chatId={el.conversationId}
            />
          )
        })}
      </div>
    )
  }

  useEffect(() => {
    setLoading(true)
    messages({ method: 'get', url: '/tech4h-messages/conversation' })
      .then((response) => {
        setLoading(false)
        let data = response.data.data

        for (let x = 0; x < data.length; x++) {
          // Set idle message
          data[x].idleMessage = findIdleMsg(data[x])

          // Set status triggers
          data[x].statusTriggers = getTriggers(data[x])

          // TODO: temporary. Adding sentTime in lastMessage (waiting for backend update)
          if (!data[x].lastMessage?.sentTime) {
            data[x].lastMessage.sentTime = data[x].lastMessage?.time
          }

          data[x].uiMemo = {
            color:
              theme.palette.random[
                Math.floor(Math.random() * (14 - 0 + 1) + 0)
              ],
          }

          // Set related components state
          data[x].relatedComponents = {
            currentChat: {
              message: '',
              scroll: 0,
            },
            history: {
              isOpen: false,
              activeTab: 0,
              activeChat: { conversationId: null, activeMsg: null },
            },
            tools: {
              activeTab: 0,
            },
            data: {
              identification: {
                isOpen: true,
                relation: null,
              },
              client: {
                isOpen: true,
              },
            },
            notes: {
              insights: {
                isOpen: true,
              },
              favoriteMessages: {
                isOpen: true,
              },
              generalInfo: {
                isOpen: true,
                tabs: [],
              },
            },
            usability: {
              isOpen: false,
              url: null,
            },
          }

          dispatch(setConversations(data[x]))
        }
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [dispatch])

  useEffect(() => {
    const tempChats = Object.values(conversations)

    if (tempChats?.length >= 0) {
      setChats(sortQueue(tempChats))
    }
  }, [conversations, setChats, sortQueue])

  useEffect(() => chats?.length >= 0 && updateFilterValues(chats), [chats])

  const chatsPendentTab = useMemo(() => {
    return (
      chats?.filter((el) => el.status === 'closed' && (!el.conversationTab || el?.pendingTab===true)) || []
    )
  }, [chats])

  const renderListPendentTab = useCallback(() => {
    if (!chatsPendentTab?.length) {
      return <></>
    }

    return (
      <div className={classes.contentPendentTabs}>
        <div className="title">
          <Typography variant="body2">
            {t('commons.pendingTabs') + ' (' + chatsPendentTab.length + ')'}
          </Typography>
        </div>
        <div className="content">
          {chatsPendentTab?.map((el, key) => (
            <ChatItem
              key={key}
              userStatus={3}
              splash={0}
              lastMessage={t('commons.lastMessage')}
              data={el}
              chatId={el.conversationId}
            />
          ))}
        </div>
      </div>
    )
  }, [chatsPendentTab])

  return (
    <>
      <div className={classes.root}>
        <div
          style={{
            display: 'flex',
            flexAlign: 'center',
            justifyContent: 'space-between',
            padding: 15,
          }}
        >
          <Icon text={size === 'small' ? '' : t('commons.queue')}>
            {loading ? <CircularProgress size={24} /> : <TimeIcon />}
          </Icon>
          <QueueIndicator />
        </div>
        <div style={{ height: 15 }} />
        <Divider style={{ marginLeft: 15, marginRight: 15 }} />
        {chats.length > 0 && renderTabs()}
        {renderList()}
        {objFeatureTab?.required && renderListPendentTab()}
        <div className={classes.fixedContainer}>
          {permissions_extra?.['phone'] && (
            <div
              className={classes.floatButton}
              onClick={() => {
                handleDialogs('telephone')
              }}
            >
              <AddIcon style={{ fontSize: 30 }} />
            </div>
          )}
          {renderFilter()}
        </div>
      </div>
      {permissions_extra?.['phone'] && (
        <CreateAttendance
          dialogOpen={dialogsOpen['telephone']}
          setDialogOpen={(e) => handleDialogs('telephone', e)}
        />
      )}
    </>
  )
}

export default MessageList
